// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"c4795615e75b3e054e14","524":"7c5d6cf6d3aaf4ede10d","810":"de1ee78d2e19dc07e2e0"}[chunkId] + ".css";
};